import React, { useRef, useState, useEffect } from "react";
import emailjs from '@emailjs/browser';

export const ContactFormThree = () => {
  const form = useRef();

  const [inputs, setInputs] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_wcidnyw', 'template_yx2dgdn', form.current, {
        publicKey: 'EOboaPXCttc42wvfs',
      })
      .then(() => {
        console.log('SUCCESS!');
        setSubmitted(true);
        setInputs({ name: '', email: '', message: '' }); // clear form
      }, (error) => {
        console.log('FAILED...', error.text);
      });
  };

  // Hide success message after 30 seconds
  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 20000);
      return () => clearTimeout(timer); // cleanup if unmounted
    }
  }, [submitted]);

  return (
    <>
      {submitted && (
        <div className="alert alert-success text-center mt-3">
          Thank you! Your message has been sent.
        </div>
      )}

      <form ref={form} onSubmit={sendEmail}>
        <div className="messages"></div>
        <div className="row">
          <div className="col-md-6 col-sm-6">
            <div className="form-floating">
              <input
                type="text"
                name="name"
                className="form-control"
                id="name"
                required
                placeholder="Your Name"
                value={inputs.name}
                onChange={handleInputChange}
              />
              <label htmlFor="name">Name</label>
            </div>
          </div>

          <div className="col-md-6 col-sm-6">
            <div className="form-floating">
              <input
                type="email"
                name="email"
                className="form-control"
                id="email"
                required
                placeholder="Your Email"
                value={inputs.email}
                onChange={handleInputChange}
              />
              <label htmlFor="email">Email</label>
            </div>
          </div>
        </div>

        <div className="form-floating">
          <textarea
            name="message"
            className="form-control"
            id="message"
            rows="7"
            required
            placeholder="Your Message"
            value={inputs.message}
            onChange={handleInputChange}
          ></textarea>
          <label htmlFor="message">Message</label>
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-color btn-circle">
            Send Message
          </button>
        </div>
      </form>
    </>
  );
};

export default ContactFormThree;
